import axiosInstance from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";



export const CalendarAPI = {

  getResources: async function (gameId, clubId) {
    const response = await axiosInstance.request({
      url: `/resources/game/` + gameId + `/club/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAllResourceAndGame: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/resource-and-game/club`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data:clubId,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getAllGames: async function (clubId) {

    const response = await axiosInstance.request({
      url: `/games/club/` + clubId,
      method: "GET",
      withCredentials: true,
      // timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getAllReservationsPost: async function (scheduleDate) {
    const response = await axiosInstance.request({
      url: `/reservation/all/date`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000,
      data: scheduleDate,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAllReservationHistory: async function (scheduleDate) {
    const response = await axiosInstance.request({
      url: `/reservation/all-reservation`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000,
      data: scheduleDate,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getPaymentTimerDetails: async function (requestInfo) {
    const response = await axiosInstance.request({
      url: `/reservation/reservation-timer-details`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000,
      data: requestInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getTotalPendingReservation: async function (scheduleDate) {
    const response = await axiosInstance.request({
      url: `/reservation/total-pending-reservation`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000,
      data: scheduleDate,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getCalendarConfig: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/calendar/config/clubId/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getCalendarConfigRsvp: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/calendar/config/rsvp/clubId/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getCalendarConfigSettings: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/calendar/settings/clubId/` + clubId,
      method: "GET",
      withCredentials: true,
      // timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getCalendarConfigCheckout: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/calendar/config/checkout/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getCalendarConfigCoachPrivacy: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/calendar/config/privacy/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCalendarTimeConfig: async function (calendarConfigTime) {
    const response = await axiosInstance.request({
      url: `/calendar/config/time`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: calendarConfigTime,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postConfirmFreeReservation: async function (userId,clubId) {
    const response = await axiosInstance.request({
      url: `/reservation/confirm/${userId}/club/${clubId}`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCalendarIntervalConfig: async function (calendarIntervalConfig) {
    const response = await axiosInstance.request({
      url: `/calendar/config/interval`,
      method: "POST",
      withCredentials: true,
      // timeout: 2000,
      data: calendarIntervalConfig,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCalendarTimezoneConfig: async function (calendarTimezoneConfig) {
    const response = await axiosInstance.request({
      url: `/calendar/config/timezone`,
      method: "POST",
      withCredentials: true,
      // timeout: 2000,
      data: calendarTimezoneConfig,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  putUpdateCalendarConfigFeature: async function (calendarConfigDTO) {
    const response = await axiosInstance.request({
      url: `/calendar/config/update/feature`,
      method: "PUT",
      withCredentials: true,
      // timeout: 2000,
      data: calendarConfigDTO,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  putUpdateRsvpConfigDetails: async function (calendarConfigDTO) {
    const response = await axiosInstance.request({
      url: `/calendar/config/update/rsvp`,
      method: "PUT",
      withCredentials: true,
      // timeout: 2000,
      data: calendarConfigDTO,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  // getReservationByUserAndStatus: async function (userId, status, clubId) {
  //   const response = await axiosInstance.request({
  //     url: `/reservation/user/`+ userId +`/status/`+status +'/club/' +clubId,
  //     method: "GET",
  //     withCredentials: true,
  //     timeout: 2000,
  //     headers: { Authorization: `Bearer ${getToken()}` },
  //   });
  //   return response.data;
  // },

  postSaveReservation: async function (reservationData) {
    const response = await axiosInstance.request({
      url: `/reservation/save`,
      method: "POST",
      withCredentials: true,
      // timeout: 2000,
      data: reservationData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  patchSaveReservation: async function (reservationData, reservationId) {
    const response = await axiosInstance.request({
      url: `/reservation/` + reservationId,
      method: "PATCH",
      withCredentials: true,
      //  timeout: 2000,
      data: reservationData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  deleteReservation: async function (reservationId, clubId, deleteInfo) {
    const response = await axiosInstance.request({
      url: `/reservation/reservationId/` + reservationId + `/clubId/` + clubId,
      method: "DELETE",
      withCredentials: true,
      //  timeout: 2000,
      data: deleteInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  deleteReservationWhenNotPaid: async function (reservationIdInfo) {
    const response = await axiosInstance.request({
      url: `/reservation/delete-reservation-when-not-paid/club/${reservationIdInfo.clubId}/user/${reservationIdInfo.userId}`,
      method: "POST",
      withCredentials: true,
      //  timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

};